var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogowhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366,
    height: 366,
    viewBox: "0 0 366 366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_558",
    x: 0,
    y: 0,
    width: 366,
    height: 366,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6933",
    "data-name": "Group 6933",
    transform: "translate(20093 23421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -20093, -23421)",
    filter: "url(#Ellipse_558)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_558-2",
    "data-name": "Ellipse 558",
    cx: 174,
    cy: 174,
    r: 174,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6932",
    "data-name": "Group 6932",
    transform: "translate(-19981.92 -23315.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6931",
    "data-name": "Group 6931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M437,332.928H403.539V361l12.249-12.3A86.3,86.3,0,0,1,437,332.928Z",
    transform: "translate(-403.539 -332.928)",
    fill: "#ed4846"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2386",
    "data-name": "Group 2386",
    transform: "translate(0 3.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6167",
    "data-name": "Path 6167",
    d: "M518.807,422a42.874,42.874,0,0,0-13.094-31.874,45.5,45.5,0,0,0-64.1.121L403.539,428.47v18.538l47.351-47.53a31.921,31.921,0,0,1,22.95-9.631A32.224,32.224,0,0,1,506.136,422a31.893,31.893,0,0,1-9.572,22.987L450.1,491.629h10c2.873,0,5.69-.122,8.457-.318l37.11-37.249A43.157,43.157,0,0,0,518.807,422Z",
    transform: "translate(-403.539 -347.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6168",
    "data-name": "Path 6168",
    d: "M425.067,359.1l-21.528,21.614v18.2l30.625-30.737q17.3-17.372,41.961-17.405,24.691-.042,42.017,17.243a59.147,59.147,0,0,1,.162,83.974L493.3,477.094c32.677-10.652,53.412-37.075,53.412-68.963V407.7c0-29.139-17.316-53.5-45.234-65.532a73.413,73.413,0,0,0-25.372-4.427Q446.1,337.982,425.067,359.1Z",
    transform: "translate(-403.539 -337.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6169",
    "data-name": "Path 6169",
    d: "M492.915,430.44A18.391,18.391,0,0,0,487.23,416.9a19.045,19.045,0,0,0-27.408.054l-56.283,56.5v18.2l65.369-65.627c3.1-3.079,6.169-3.115,9.273-.032q4.448,4.457-.157,9.1l-64.511,64.76h18.459l55.309-55.531A18.768,18.768,0,0,0,492.915,430.44Z",
    transform: "translate(-403.539 -355.429)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.5ab48c80622f533d564dc74aa2ad442f.svg";
export { ForwardRef as ReactComponent };